module.exports = __webpack_public_path__ + "img/auburn-city.5fa1e969.jpg";